import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from '@mui/material';
import { bool, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const TYPE_LABELS = {
  skills: 'AgenticChatFlow.DeleteExclusiveSkills',
  tools: 'AgenticChatFlow.DeleteExclusiveTools',
  tags: 'AgenticChatFlow.DeleteExclusiveTags',
  metrics: 'AgenticChatFlow.DeleteExclusiveMetrics',
};

const AgentDeleteExclusivePanel = ({
  preview = null,
  loading = false,
  checked = false,
  onCheckedChange,
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
        <CircularProgress size={16} />
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {I18n.t('AgenticChatFlow.DeleteExclusiveLoading')}
        </Typography>
      </Box>
    );
  }

  const totals = preview?.totals?.resources || 0;
  if (!totals) {
    return null;
  }

  const groups = Object.entries(TYPE_LABELS)
    .map(([key, labelKey]) => ({
      key,
      label: I18n.t(labelKey),
      items: preview?.exclusive?.[key] || [],
    }))
    .filter(group => group.items.length > 0);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 1,
        }}
      >
        {I18n.t('AgenticChatFlow.DeleteExclusiveSummary', { count: totals })}
      </Typography>
      {groups.map(group => (
        <Box key={group.key} sx={{ mb: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              color: 'text.secondary',
            }}
          >
            {group.label}
          </Typography>
          <Typography variant="body2" component="div">
            {group.items.map(item => item.name).join(', ')}
          </Typography>
        </Box>
      ))}
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={e => onCheckedChange(e.target.checked)} />}
        label={I18n.t('AgenticChatFlow.DeleteExclusiveCheckbox')}
      />
    </Box>
  );
};

AgentDeleteExclusivePanel.propTypes = {
  preview: object,
  loading: bool,
  checked: bool.isRequired,
  onCheckedChange: func.isRequired,
};

export default AgentDeleteExclusivePanel;
